import React, { useState, useEffect, useCallback } from "react";
import { Form } from "react-bootstrap";
import { getremoteInquirydataApi } from "../../../Api/iron"

const initData = {
    firstname: "",
    lastname: "",
    email: "",
    phone: "",
    height_ft: "",
    height_in: "",
    wrist_to_floor: "",
    shoulder_to_wrist: "",
    elbow_to_wrist: ""
};
function TabFormData({ project_id, remortFittingFormData }) {
 
    const [validated, setValidated] = useState(false);
    const [formData, setFormData] = useState(undefined);
    const [userProfileData, setUserProfileData] = useState(undefined);


    const getRemortFittingDataById = () => {
        // getremoteInquirydataApi({ id: project_id }).then((res) => {
        //     if (res?.code === 200) {
        //         const userData = res.data.data;
        //         console.log("userData", userData);
        //         setUserProfileData(userData);
        //     } else {
        //         alert(res.data?.message);
        //     }
        // }).catch((err) => {
        //     alert(err);
        // })
        if(remortFittingFormData){
            setUserProfileData(remortFittingFormData);
        }
    }


    useEffect(() => {
        if (project_id) {
            getRemortFittingDataById();
        }
    }, [project_id]); // Add the function to the dependency array

    useEffect(() => {
    },[userProfileData]);

    useEffect(() => {
    }, [formData]); // Add the function to the dependency array

    return (
        <>


            {
                userProfileData ? (
                    <>
                        <Form noValidate validated={validated}>
                            <div className="row gx-2">
                                <div className="col-md-6 form-group" controlid="validationCustom01">
                                    <input type="text" name="f-name" disabled value={userProfileData.firstname} className="form-control dashboard-input-box-3" placeholder="First name" required />
                                    <Form.Control.Feedback type="invalid">
                                        Please enter a first name.
                                    </Form.Control.Feedback>
                                </div>
                                <div className="col-md-6 form-group" controlid="validationCustom02">
                                    <input type="text" name="l-name" disabled value={userProfileData.lastname} className="form-control dashboard-input-box-3" placeholder="Last name" required />
                                    <Form.Control.Feedback type="invalid">
                                        Please enter a last name.
                                    </Form.Control.Feedback>
                                </div>
                                <div className="col-6 col-md-3 form-group" controlid="validationCustom01">
                                    <select disabled value={userProfileData.height_ft} class="form-select form-control dashboard-input-box-3 select-custom-boxx" aria-label="Default select example">
                                        <option value={0}>ft.</option>
                                        <option value="4">4 ft.</option>
                                        <option value="5">5 ft.</option>
                                        <option value="6">6 ft.</option>
                                        <option value="7">7 ft.</option>
                                    </select>
                                    <Form.Control.Feedback type="invalid">
                                        Please select a ft.
                                    </Form.Control.Feedback>
                                </div>
                                <div className="col-6 col-md-3 form-group" controlid="validationCustom01">
                                    <select disabled value={userProfileData.height_in} class="form-select form-control dashboard-input-box-3 select-custom-boxx" aria-label="Default select example">
                                        <option value={0}>in.</option>
                                        <option value="1">0 in.</option>
                                        <option value="2">1 in.</option>
                                        <option value="3">2 in.</option>
                                        <option value="4">3 in.</option>
                                        <option value="5">4 in.</option>
                                        <option value="6">5 in.</option>
                                        <option value="7">6 in.</option>
                                        <option value="8">7 in.</option>
                                        <option value="9">8 in.</option>
                                        <option value="10">9 in.</option>
                                        <option value="11">10 in.</option>
                                        <option value="12">11 in.</option>
                                    </select>
                                    <Form.Control.Feedback type="invalid">
                                        Please select a in.
                                    </Form.Control.Feedback>
                                </div>
                                <div className="col-12 col-md-6 form-group" controlid="validationCustom01">
                                    <select disabled value={userProfileData.dexterity} class="form-select form-control dashboard-input-box-3 select-custom-boxx" aria-label="Default select example">
                                        <option value={0}>Dexterity</option>
                                        <option value="1">Right Handed</option>
                                        <option value="2">Left Handed</option>
                                    </select>
                                    <Form.Control.Feedback type="invalid">
                                        Please select a Dexterity
                                    </Form.Control.Feedback>
                                </div>
                                <div className="col-md-12 form-group" controlid="validationCustom03">
                                    <input disabled value={userProfileData.phone} type="tel" name="name" pattern="[0-9]{8,}" title="Please enter a 8-digit phone number." className="form-control dashboard-input-box-3" placeholder="Phone" required />
                                    <Form.Control.Feedback type="invalid">
                                        Please enter a 8-digit phone number.
                                    </Form.Control.Feedback>
                                </div>
                                <div className="col-md-12 form-group" controlid="validationCustom04">
                                    <input disabled value={userProfileData.email} type="email" className="form-control dashboard-input-box-3" name="email" placeholder="Email" required />
                                    <Form.Control.Feedback type="invalid">
                                        Please choose a email.
                                    </Form.Control.Feedback>
                                </div>
                                <div className="col-md-12 form-group" controlid="validationCustom04">
                                    <input disabled value={userProfileData.address} type="text" className="form-control dashboard-input-box-3" name="address" placeholder="Street Address, Apt. #" required />
                                    <Form.Control.Feedback type="invalid">
                                        Please choose a street address.
                                    </Form.Control.Feedback>
                                </div>
                                <div className="col-4 col-md-6 form-group mb-0" controlid="validationCustom01">
                                    <input type="text" disabled value={userProfileData.city} name="f-name" className="form-control dashboard-input-box-3" placeholder="City" required />
                                    <Form.Control.Feedback type="invalid">
                                        Please enter City
                                    </Form.Control.Feedback>
                                </div>
                                <div className="col-4 col-md-3 form-group mb-0" controlid="validationCustom02">
                                    <input type="text" disabled value={userProfileData.state} name="l-name" className="form-control dashboard-input-box-3" placeholder="State" required />
                                    <Form.Control.Feedback type="invalid">
                                        Please enter State
                                    </Form.Control.Feedback>
                                </div>
                                <div className="col-4 col-md-3 form-group mb-0" controlid="validationCustom02">
                                    <input type="text" disabled value={userProfileData.zip} name="l-name" className="form-control dashboard-input-box-3" placeholder="Zip Code" required />
                                    <Form.Control.Feedback type="invalid">
                                        Please enter Zip Code
                                    </Form.Control.Feedback>
                                </div>
                            </div>
                        </Form>
                    </>
                ) : (<>hello </>)
            }






        </>
    );
}

export default TabFormData;